<template>
	<div class="travel-time"><strong>Travel Time:</strong> {{ $store.getters.getTotalTimeString }}</div>
</template>

<script>
export default {
	name: "TotalTime"
}
</script>
